import React, {useEffect, useState} from 'react';
import {Box, ThemeProvider} from '@mui/material';
import NavBar from '../../pieces/navbar/navbar';
import * as allConstants from '../../constants/allConstants';
import myTheme from '../../styles/myStyles';
import DisplayListsPageWrapper from '../wrappers/displayListsPageWrapper';
import AllCompaniesGrid from './allCompaniesGrid';
import {useNavigate} from 'react-router-dom';
import ListPageHeader from '../../pieces/listPageHeader';
import {ListViewHeader} from '../jobs/components/listViewHeader';
import {useGridViewState} from '../../hooks/useGridViewState';
import usePagination from '../../hooks/usePagination';
import {globalUseClasses} from '../../styles/globalClasses';
import {NewPermissionGate} from '../../permissions/permissionGate';
import {COMPANY_ELEMENTS, companyRules} from '../../permissions/companyAccessControl';
import {urlSearchParams} from '../../baseUrls';
import ModalWrapper, {ModalContentWrapper} from '../../pieces/modals/modalWrapper';
import {EditFinancialForm} from './panels/editFinancialForm';
import {SetCompanyAdminForm} from './panels/setCompanyAdminForm';

const AllCompaniesView = () => {
  const viewController = useGridViewState();
  const navigate = useNavigate();
  const pagination = usePagination();
  const classes = globalUseClasses();
  const [showEditFinancial, setShowEditFinancial] = useState(false);
  const [showSetCompanyAdmin, setShowSetCompanyAdmin] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(undefined);
  const [selectedCompanyForAdminUpdate, setSelectedCompanyForAdminUpdate] = useState(undefined);

  //console.log('inside all company view');


  useEffect(()=> {
    /**
     * This part is handling only following case: on companies view, select company and inpersonate it => regirect to company view page.
     * redirect on logout would be handled by App routes.
     */
    if(!viewController.user.id) return;
    const userCanViewPage = NewPermissionGate({
      user: viewController.user,
      elementPermissions: companyRules[COMPANY_ELEMENTS.allCompaniesNavLink],
    });
   
    //console.log('view controller properties');
    //console.log(viewController);

    if(!userCanViewPage && !viewController.isParentCompany) {

      //console.log('redirect to detail');

      if(viewController.companyId) {
        navigate(`${allConstants.PATH.COMPANY}?${urlSearchParams.companyId}=${viewController.companyId}`);
      } else {
        navigate(allConstants.PATH.ACCESS_DENIED);
      }

    }
  }, [viewController.companyId]);

  const getHeaderComponent = ()=> {
    let title = 'All Companies';

    if(pagination.totalItemsCount) {
      title = `${title} (${pagination.totalItemsCount})`;
    }
    return (
      <ListViewHeader title={title}
        //gridEnum={JobGridEnum}
        pagination={pagination}
        //handleClick={handleClick}
        // menuController={menuController}
        // extendedFilters={shouldHideFilters() ? null : extendedFilters}
        viewController={viewController}
      />
    );
  };

  const headerComponent = <ListPageHeader 
    viewController={viewController}
    headComponent = {getHeaderComponent()}
    addHandler={()=>{navigate(`${allConstants.PATH.REGISTER_COMPANY}?${urlSearchParams.invite}=true`);}}
    showAddButton = {NewPermissionGate({
      user: viewController.user,
      elementPermissions: companyRules.inviteButton,
    })}

    totalItems={pagination.totalItemsCount}
  >
    {pagination.ItemsController}
  </ListPageHeader>;

  const editFinancialHandler = (companyData) => {
    setSelectedCompany(companyData);
    setShowEditFinancial(true);
  };

  const cancelEditFinancialHandler = () => {
    setSelectedCompany(undefined);
    setShowEditFinancial(false);
  };

  const setCompanyAdminHandler = (companyData) => {
    setSelectedCompanyForAdminUpdate(companyData);
    setShowSetCompanyAdmin(true);
  };

  const cancelSetCompanyAdminHandler = () => {
    setSelectedCompanyForAdminUpdate(undefined);
    setShowSetCompanyAdmin(false);
  };

  const onSetCompanyAdminSuccess = () => {
    viewController.refreshGrid();
    cancelSetCompanyAdminHandler();
  };

  return (
    <>
      <NavBar/>
      <ThemeProvider theme={myTheme}>
        <Box className={classes.page}>
          {selectedCompany && showEditFinancial && <ModalWrapper
            handleClose={cancelEditFinancialHandler}
            open={true}
            modalName={'Edit Financial'}
            preventScroll={false}
          >
            <EditFinancialForm id={selectedCompany?.[allConstants.COMPANY_FIELDS.ID.api_name]} handleClose={cancelEditFinancialHandler}/>
          </ModalWrapper>}
          {selectedCompanyForAdminUpdate && showSetCompanyAdmin && <ModalWrapper
            handleClose={cancelSetCompanyAdminHandler}
            open={true}
            width='1000px'
            preventScroll={false}
          >
            <ModalContentWrapper
              handleClose={cancelSetCompanyAdminHandler}
              header={`Set/Update Company Admin - ${selectedCompanyForAdminUpdate?.[allConstants.COMPANY_FIELDS.NAME.api_name] || ''}`}
              headerVariant={'div'}
            >
            
              <SetCompanyAdminForm
                companyId={selectedCompanyForAdminUpdate?.[allConstants.COMPANY_FIELDS.ID.api_name]}
                adminUserId={selectedCompanyForAdminUpdate?.[allConstants.COMPANY_FIELDS.ADMIN_USER_ID.api_name]}
                handleClose={cancelSetCompanyAdminHandler}
                onSuccess={onSetCompanyAdminSuccess}
              />
            </ModalContentWrapper>
          </ModalWrapper>}
          <DisplayListsPageWrapper
            headerComponent={headerComponent}>
            <AllCompaniesGrid viewController={viewController} 
              editFinancial={editFinancialHandler}
              setCompanyAdmin={setCompanyAdminHandler}
              pagination={pagination}/>
            {pagination.PageController}
          </DisplayListsPageWrapper>
        </Box>
      </ThemeProvider>
    </>
  );
};
export default AllCompaniesView;
